import { render, staticRenderFns } from "./InstructorForm.vue?vue&type=template&id=612b3e41&"
import script from "./InstructorForm.vue?vue&type=script&lang=js&"
export * from "./InstructorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports